import Button from 'components/shared/Button/Button';
import Icon from 'components/shared/Icon/Icon';
import Modal from 'components/shared/Modal/Modal';
import Typography from 'components/shared/Typography/Typography';

const ErrorPayment = ({ message, onTryAgain, onClose }) => {
  const errorMessage = typeof message === 'string' ? message + '!' : 'Payment failed!';

  return (
    <Modal
      isOpen={true}
      handleClose={onClose}
      isCentered
      customHeader={
        <Typography variant="label" size="medium" weight="semibold">
          Payment failed!
        </Typography>
      }
      footer={
        <div className="flex flex-row flex-wrap content-center items-center justify-center gap-2">
          <Button
            text="Close"
            style="outlined"
            color="neutral"
            shade={700}
            size="small"
            onClick={onClose}
          />
          <Button text="Try Again" size="small" onClick={onTryAgain} />
        </div>
      }
      bodyClassName="bg-white pt-4 pb-6">
      <div className="mx-auto flex h-full max-w-[366px] flex-col items-center justify-center gap-3">
        <Icon icon="illustration-payment-failed" />
        <div className="flex flex-col items-center gap-1 text-center">
          <Typography variant="p" size="medium" weight="medium">
            {errorMessage}
          </Typography>
          <Typography variant="p" color="neutral-600" size="small">
            We couldn’t process your payment. Please check your card or try again with a different
            method.
          </Typography>
        </div>
      </div>
    </Modal>
  );
};

export default ErrorPayment;
